import { useState, useEffect, useCallback, useMemo } from 'react';
import React from 'react';
import { getDmImei, getDms, writeRsCmdSettings } from '../../../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import { RS_DEVICE_TYPES } from '../../../Utils/ConfigMaps';
import '../RsConfig.css'

export default React.memo (function SelectTypeRs() {
    const parameter = useSelector((state) => state.dmimei.data[0]);
    const iduser = localStorage.getItem('iduser');
    const dispatch = useDispatch();

    // Состояние для хранения выбранных значений
    const [selectedDevice, setSelectedDevice] = useState(null);

     // Инициализация состояния при получении данных
     useEffect(() => {
        if (parameter) {
            // Устанавливаем текущий тип устройства
            const currentDevice = parameter?.typeRsDevice;
            setSelectedDevice(currentDevice);
        }
    }, [parameter?.typeRsDevice]);

    // Находим текущее значение для select типа устройства
    const currentDeviceValue = useMemo(() => {
        return selectedDevice - 1;
      }, [selectedDevice]);
      //Обработчик сохранение нового типа
     const handleTypeChange = async(e) => {
        const value = parseInt(e.target.value);
        const newType = value*1+1;
        setSelectedDevice(newType);
        const num = 40;
        if (parameter?.typeRsDevice !== (newType)) {
        dispatch(writeRsCmdSettings(parameter?.imei, newType, num))
        .then(() => dispatch(getDmImei(parameter?.imei)))
        .catch((error) => console.error("Ошибка при сохранении или обновлении данных: ", error));
        }
        };

    return (
            <div className='ParamInput'>
                <label>Тип устройства RS485</label>
                <select className='DmSelect' value={currentDeviceValue} onChange={handleTypeChange}>
                    {RS_DEVICE_TYPES.map((device, index) => (
                        <option key={device.value} value={index}>
                        {device.label}
                        {device.value === selectedDevice ? ' (текущий)' : ''}
                        </option>
                    ))}
                </select>
            </div>
    );
});